/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { defineComponent } from '@vue/composition-api';
import props from './menu-group-props.js';
import { usePrefixClass } from '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

var _MenuGroup = defineComponent({
  name: "TMenuGroup",
  props: props,
  setup: function setup() {
    var classPrefix = usePrefixClass();
    return {
      classPrefix: classPrefix
    };
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": "".concat(this.classPrefix, "-menu-group")
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-menu-group__title")
    }, [this.title]), this.$slots["default"]]);
  }
});

export { _MenuGroup as default };
//# sourceMappingURL=menu-group.js.map
